<template src="./Add.html"></template>

<script>
import { showAlert } from "@/utils/helpers";

export default {
  created() {
    this.$store.dispatch("lookups/getPharmacyMedicines");
  },
  computed: {
    medicines() {
      return [
        ...this.$store.state.lookups.medicines
      ]
    }
  },
  data() {
    return {
      expanded: [],
      patient: {
        fullName: null,
        fileNo: null,
      },

      patients: [],
      selectedPatient: {
        fullName: null,
        fileNo: null
      },
      showResult: false,
      showBtn: false,
      dialog: false,
      searchTrem: null,

      stock: [],
      formDialog: false,
      vm: {
        medicineId: null,
        items: []
      },
      medicine: {
        medicineId: null,
        dispensedQuantity: null,
      },
      indexItem: null,
      editFlag: false,
      headers: [
        { text: 'اسم الدواء', value: 'medicineId' },
        { text: 'الكمية', value: 'dispensedQuantity' },
        { text: 'الاجراءات', value: 'actions', sortable: false },
      ],


    };
  },
  methods: {
    ChangeMedicine() {
     let medicine = this.medicines.forEach(element => {
        if (element.value == this.medicine.medicineId) {
         return element;
        }
      });
      this.medicine.price = medicine.price;
      this.medicine.quantity = medicine.quantity;
    },
    SearchPatient() {
      this.showResult = false;
      this.patients = [];
      this.selectedPatient.fullName = null;
      this.selectedPatient.fileNo = null;
      this.vm = {
        medicineId: null,
        items: []
      };
      if (this.searchTrem == null || this.searchTrem == "" || this.searchTrem.length < 9) {
        showAlert(`الرجاء ادخال رقم الهاتف`);
        return false;
      }

      this.$store
        .dispatch("pharmacy/search", { searchTrem: this.searchTrem })
        .then((res) => {

          if (res.statusCode == 1) {
            this.showResult = true
            this.patients = res.patients;
            this.dialog = true;
          }
        }).catch(() => { });
    },
    confirmDialog() {
      let that = this;
      this.patients.forEach((el) => {
        if (that.vm.patientId == el.id) {

          that.selectedPatient = el
          return el
        }
      });

      this.dialog = false
    },
    //----------------------------------------------------//

    confirm() {
      if (this.vm.items.length == 0) {
        showAlert(`يجب ادخال عنصر واحد على الاقل`);
        return false;
      }
      this.$store
        .dispatch("pharmacy/add", this.vm)
        .then(() => {
          this.back();
        })
        .catch(() => { });
    },

    getMedicinesStock() {
      if (this.medicine.medicineId == null) {
        showAlert(`يجب اختيار الدواء `);
        return false;
      } else if (this.medicine.dispensedQuantity == null) {
        showAlert(`يجب ادخال الكمية   `);
        return false;
      }

      let isFound = false;
      this.vm.items.forEach(element => {
        if (element.medicineId == this.medicine.medicineId) {
          showAlert(`الدواء مضاف مسبقا`);
          isFound = true;
        }
      });

      if (isFound) {
        showAlert(`الدواء مضاف مسبقا`);
        return false;
      }


      this.stock = [];
      this.$store
        .dispatch("pharmacy/getMedicinesStock", this.medicine)
        .then((res) => {
          this.stock = res;
          if (res.length > 0) {
            this.AddItem()
          }
        })
        .catch(() => { });

    },

    AddItem() {

      this.vm.items.push({
        medicineId: this.medicine.medicineId,
        dispensedQuantity: this.medicine.dispensedQuantity,
        stock: this.stock,
      });

      this.medicine.medicineId = null;
      this.medicine.dispensedQuantity = null;
      this.stock = [];

      this.$refs.form.reset();
    },
    removeItem(index) {
      this.vm.items.splice(index, 1);
    },
    back() {
      this.$emit("back");
    },
  },
};
</script>